/* eslint-disable no-restricted-syntax */
export const HUNT_THEME = 'hunt'
export const OFFROAD_THEME = 'offroad'
export const BACKCOUNTRY_THEME = 'backcountry'
export const FISH_THEME = 'fish'

/**
 * Returns a set of standardized classnames for the components theme.
 * classes used in @/styles/systems/_themes to apply
 * the appropriate color scheme for each theme
 * @param theme
 * @returns classes for theme
 */
export function getThemeClasses(theme: string) {
  return {
    backcountryTheme: theme === BACKCOUNTRY_THEME,
    huntTheme: theme === HUNT_THEME,
    offroadTheme: theme === OFFROAD_THEME,
    fishTheme: theme === FISH_THEME,
  }
}
